import { LandingCard } from "./landingCards";

export const TRLandingCards: LandingCard[] = [
  {
    title: "Start application",
    icon: "/assets/images/Thumbnail.svg",
    link: "/tuition/apply",
    linkText: "Submit a new Tuition reimbursement application",
  },
  {
    title: "View my status and upload documents",
    icon: "/assets/images/heart-illustrative.svg",
    link: "/tuition/upload-document",
    linkText:"Check your application status and upload supporting documents"
  },
  {
    title: "Manager portal",
    icon: "/assets/images/Manager-Thumbnail.svg",
    link: "/tuition/manager-portal",
    linkText: "Review, approve or deny applications",
    managerOnly:true
  },
 
  {
    title: "Tuition reimbursement policy",
    icon: "/assets/images/resources-illustrative.svg",
    link: "",
    linkText: "Review your market's TR policy",
    target: "_blank",
  },
  {
    title: "Resources",
    icon: "/assets/images/resources-illustrative.svg",
    link: "https://www.kpcareerplanning.org/prd/tuition_reimbursement.php",
    linkText: "FAQs, sample documentation and step-by-step guide",
    target: "_blank",
  },
  {
    title: "My employee information",
    icon: "/assets/images/resources-illustrative.svg",
    link: "/tuition/overview",
    linkText: "Add preferred email, self-reported manager, view TR balances",
    target: "_blank",
  },
];
 
export const TRLinks=[{
    linkName:'Create a new education benefit application',
    linkUrl:'/tuition/apply'
},
{
    linkName: 'Ben Hundall memorial trust',
    linkUrl: 'https://bhmt.org/',
    target: '_blank', 
},
{
  linkName: "SEIU-UHW - west and joint employer Education fund",
  linkUrl: 'https://www.seiu-uhweduc.org/',
  target: '_blank', 
},
]